// shared.module.ts

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppsIntergrationComponent } from '../Components/apps-intergration/apps-intergration.component';

@NgModule({
  declarations: [
    AppsIntergrationComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AppsIntergrationComponent
  ]
})

export class AppsIntergrationModule { }
